import { Component, Input, OnInit } from "@angular/core";
import { Chart } from "chart.js";
import { AuthService } from "../../services/auth-service/auth.service";
import { DashboardService } from "../../services/dashboard/dashboard.service";

@Component({
  selector: "app-bar-chart",
  templateUrl: "./bar-chart.component.html",
  styleUrls: ["./bar-chart.component.scss"],
})
export class BarChartComponent implements OnInit {
  @Input() datasetip: any;
  @Input() labelsip: any;
  @Input() barChartTitle: any;
  @Input() legend: boolean = false;

  public chart: any = null;
  role: any;

  constructor(
    private dashboardService: DashboardService,
    private authService: AuthService
  ) {
    console.log("lthis.abelsip", this.labelsip);
    console.log("this.legend", this.legend);
    console.log("this.barChartTitle", this.barChartTitle);
    this.role = this.authService.getPersonId();
    if (this.role == "1") {
      this.dashboardService._getSABarChartObserver.subscribe((res) => {
        // console.log('bar observers ', res);
        this.datasetip = res;
        this.renderChart();
      });
      this.dashboardService._getSABarCharLablesObserver.subscribe((res) => {
        // console.log('labels observers ', res);
        this.labelsip = res;
        this.renderChart();
      });
    }
    if (this.role == "2") {
      this.dashboardService._getSPABarChartObserver.subscribe((res) => {
        this.datasetip = res;
        // console.log('spa bar observers ', this.datasetip);
        this.renderChart();
      });
      this.dashboardService._getSPABarChartLabelObserver.subscribe((res) => {
        this.labelsip = res;
        // console.log('spa labels observers ', this.labelsip);
        this.renderChart();
        console.log("this.labelsip", this.labelsip);
      });
    }
  }
  ngOnInit() {
    // console.log(this.datasetip, this.labelsip, this.barChartTitle, this.legend);

    this.renderChart();
  }

  renderChart() {
    this.chart ? this.chart.destroy() : "";

    Chart.defaults.global.animation.duration = 3000;

    this.chart = new Chart("canvas", {
      type: "bar",
      data: {
        labels: this.labelsip,
        datasets: this.datasetip,
      },
      options: {
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
                callback: function (label: any, index, labels) {
                  // when the floored value is the same as the value we have a whole number
                  if (Math.floor(label) === label) {
                    return label;
                  }
                },
                autoSkip: true,
                maxTicksLimit: 6,
              },

              gridLines: {
                display: true,
                drawBorder: true,
                // lineWidth: 0
              },
            },
          ],
          xAxes: [
            {
              gridLines: {
                display: true,
                drawBorder: true,
                // lineWidth: 0
              },
            },
          ],
        },
        legend: {
          display: this.legend,
          position: "bottom",
          labels: {
            usePointStyle: true,
          },
        },
      },
    });
  }
}
